<template>
    <Breadcrumbs main="Form Widgets" title="Touchspin" />
    <div class="container-fluid">
        <div class="bootstrap-touchspin">
            <div class="row">
                <defaultTouchspin />
                <outlinedTouchspin />
                <IconsTouchspin />
                <postfixTouchspin />
                <roundedTouchspin />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/defaultTouchspin.vue"))
const outlinedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/outlinedTouchspin.vue"))
const IconsTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/IconsTouchspin.vue"))
const postfixTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/postfixTouchspin.vue"))
const roundedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/roundedTouchspin.vue"))
</script>